// API configuration matching portal/src/config/development.js
// In development: both point to https://api.folktale.local
// In production: use environment variables

export const API_BASE_URL =
  process.env.NEXT_PUBLIC_STORYBOOK_BASE_URL || "https://api.folktale.local";

export const CONSOLE_API_BASE_URL =
  process.env.NEXT_PUBLIC_STORYBOOK_BASE_URL || "https://api.folktale.local";

export const UPLOAD_BASE_URL =
  process.env.NEXT_PUBLIC_STORYBOOK_UPLOAD_BASE_URL || "https://api.folktale.local";
